import { VariantProps, cva } from 'class-variance-authority';
import React, { ButtonHTMLAttributes, FC, forwardRef } from 'react';
import { cn } from '../../lib/utils';

// Customized button variations
const buttonVariants = cva(
  `RXC_BUTTON tw-font-primary tw-text-BaseTextLight tw-text-sm tw-font-bold tw-leading-5 tw-justify-center tw-items-stretch tw-px-6 tw-py-2.5 max-md:tw-px-5`,
  {
    variants: {
      variant: {
        primary:
          'RXC_BUTTON_PRIMARY tw-bg-BasePrimary tw-uppercase tw-rounded-btn hover:tw-bg-DarkPrimary',
        secondary:
          'RXC_BUTTON_SECONDARY tw-text-BasePrimary tw-bg-BaseSecondary tw-rounded-full tw-border tw-border-BasePrimary',
        inverted:
          'RXC_BUTTON_INVERTED tw-bg-white tw-uppercase tw-text-BaseTextDark tw-border tw-border-BasePrimary',
        link: 'RXC_BUTTON_LINK tw-text-BasePrimary tw-underline hover:tw-no-underline',
        badge:
          'RXC_BADGE tw-bg-BasePrimary tw-rounded-full tw-font-normal tw-text-xs',
      },
      size: {
        xs: 'tw-text-xs tw-py-1 tw-px-2',
        small: 'tw-py-2 tw-px-4',
        large: 'tw-text-xl tw-py-3 tw-px-6',
      },
    },
    defaultVariants: {
      size: 'small',
      variant: 'primary',
    },
  }
);

// It is our ButtonProps interafce it extends ButtonHTMLAttributes of HTMLButtonElement interface
// Also extends from class-variance-authority lastly we passed our forwarded Reference type
export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  ref?: React.Ref<HTMLButtonElement>;
}

const Button: FC<ButtonProps> = forwardRef(
  ({ size, variant, className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(buttonVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </button>
    );
  }
);

export default Button;
